<p class="control-title"><strong>Visitor type</strong></p>
<ui-dropdown-simple
    [keyName]="'name'"
    [valueName]="'id'"
    [optionsList]="typeOfVisitList"
    [selectedValue]="selectedValue"
    [placeholder]="'Select'"
    [showListOnTop]="true"
    [disabled]="disabled()"
    (valueChange)="onSelectionChange($event)">
</ui-dropdown-simple>
